import { createSelector } from '@ngrx/store';
import { AppState, getAppState } from '../registration';
import { UiState } from '../reducers';
import { NotificationData } from '@models/*';

export const getUiState = createSelector(getAppState, (state: AppState) => state.ui);

export const getToasts = createSelector(getUiState, (state: UiState) => state.toasts);
export const getGalleryData = createSelector(getUiState, (state: UiState) => state.galleryData);
export const getNotifications = createSelector(getUiState, (state: UiState) => state.notifications);
export const getrefreshMandatory = createSelector(getUiState, (state: UiState) => state.refreshMandatory);
export const getOpenedNotificationId = createSelector(getUiState, (state: UiState) => state.openedNotificationId);
export const getAnimatingUpdatedTourIds = createSelector(getUiState, (state: UiState) => state.animatingUpdatedTourIds);

export const getOpenedNotification = createSelector(
    getNotifications,
    getOpenedNotificationId,
    (notifications: NotificationData[], id: number) => notifications.find(item => item.id === id)
);
